import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transfer-validation',
  templateUrl: './transfer-validation.component.html',
  styleUrls: ['./transfer-validation.component.css']
})
export class TransferValidationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
